import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getEventLists } from "../../networkCalls";
import FotterMain from "../BaseComponents/FotterMain";
import Header from "../BaseComponents/Header";
import LoadingCellFullPage from "../LoadingCell/LoadingCellFullPage";
import parse from "html-react-parser";
import SEO from "../BaseComponents/SEO";
import { Pagination } from "@mui/material";
const EventListing = () => {
  const [loading, setLoading] = useState(false);
  const [resultData, setResultData] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = useState(1);
  const pullPressReleaseApi = () => {
    var data = new FormData();
    data.append("page", page);
    setLoading(true);
    getEventLists(data).then((res) => {
      setLoading(false);
      //console.log('dsfdf', res?.data?.eventList )
      switch (res.data.status) {
        case 1:
          setPageCount(res?.data?.Pagination);
          setResultData(res?.data?.eventList);
          //setErrMessage('');
          return true;
        case 0:
          //setErrMessage(res.data.msz);
          break;
        default:
          return;
      }
    });
  };

  useEffect(() => {
    pullPressReleaseApi();
  }, [page]);

  const toTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    toTop();
  }, []);
  // const [page, setPage] = React.useState(1);
  // const [pageCount, setPageCount] = useState(10);
  const handleChange = (event, value) => {
    setPage(value);
  };
  return (
    <>
      <SEO
        title="Honda India Power Products | Honda Events"
        description="Honda India Power Products Events"
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/events"
        type="Website"
      />
      <Header />
      {loading ? (
        <>
          <LoadingCellFullPage />
        </>
      ) : (
        <>
          <div className="innerpagebg pt-5 pb-5">
            <div className="container mb-4">
              <div className="row">
                <div className="col-12  m-auto">
                  <div className="align-items-center text-center">
                    <h4 className="d-inline-block m-0 fw-bold text-uppercase">
                      <span className="txtred">Newsroom</span>{" "}
                      <span className="txtdgray"></span>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              {resultData && resultData?.length > 0 ? (
                <>
                  <div className="row">
                    {resultData &&
                      resultData?.map((data) => (
                        <div key={data?.dataId} className="col-lg-6 col-12">
                          <div className="post-card mb-4 d-flex align-items-center ">
                            <div className="py-3">
                              <Link to={data?.type === 1 ? `/events/${data?.slug}`:`/press-release/${data?.slug}`}>
                                <img
                                  alt=""
                                  className="post-card__image_event"
                                  src={data?.image}
                                />
                              </Link>
                            </div>
                            <div className="post-card__content">
                              <div className="">
                                <span className="txtlgeay">{data?.date}</span>
                              </div>
                              <div className="post-card__title mb-2">
                                <h2>
                                  <Link
                                    to={data?.type === 1 ? `/events/${data?.slug}`:`/press-release/${data?.slug}`}
                                    className="txtdgray"
                                  >
                                    {data?.title}
                                  </Link>
                                </h2>
                              </div>
                              <div className="post-card__date f12 mt-2">
                                <Link
                                  to={data?.type === 1 ? `/events/${data?.slug}`:`/press-release/${data?.slug}`}
                                  className="txtred"
                                >
                                  MORE...
                                </Link>
                              </div>
                            </div>
                          </div>

                          {/* <div className="post-card mb-4">
                                       <div className="post-card__image" style={{maxHeight:'250px', minHeight:'250px', overflow:'hidden'}}><Link to={`/events/${data?.slug}`}>
                                         <img alt="" className='img-fluid' src={data?.image} /></Link></div>
                                       <div className="post-card__content">
                                         <div className="post-card__category"><span className='txtlgeay'>{data?.date}</span></div>
                                         <div className="post-card__title mb-2">
                                           <h2 ><Link to={`/events/${data?.slug}`} className='txtdgray'>{data?.title}</Link></h2>
                                         </div>
                                         <div className="post-card__date f12 mt-2"><Link to={`/events/${data?.slug}`} className='txtred'>MORE...</Link></div>
                                       </div>
                                     </div> */}
                        </div>
                      ))}
                    <div className="col-lg-12 col-12 d-flex justify-content-center w-100">
                      {/* <div className='d-flex justify-content-between w-100'> */}
                      <Pagination
                        color="error"
                        variant="outlined"
                        // shape="rounded"
                        count={pageCount}
                        page={page}
                        onChange={handleChange}
                      />
                      {/* </div> */}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card text-center p-4">
                        No Records Found
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
      <FotterMain />
    </>
  );
};

export default EventListing;
